<script>
    import { auth, googleProvider, twitterProvider, facebookProvider } from '../../../firebase';
    import { user } from '../../../store';

    import Icon from '../../atoms/Icon.svelte';
    import Splash from '../../organisms/Intro/Splash.svelte';

    import facebook from '../../../../public/assets/svg/24/facebook.svg';
    import google from '../../../../public/assets/svg/24/google.svg';
    import twitter from '../../../../public/assets/svg/24/twitter.svg';

    let showLoading = false;
    let loginFailed = false;

    function loginGoogle() {
        showLoading = true;
        auth.signInWithPopup(googleProvider).catch(error => loginFailed = true);
    }

    function loginTwitter() {
        showLoading = true;
        auth.signInWithPopup(twitterProvider).catch(error => loginFailed = true);
    }
    
    function loginFacebook() {
        showLoading = true;
        auth.signInWithPopup(facebookProvider).catch(error => loginFailed = true);
    }

</script>

<style lang="scss" src="./Login.scss"></style>

{#if !showLoading}
<div class="login">
    <img class="login__header" width="94" src="./assets/svg/logo_text.svg" alt="Originea">
    <h1 class="login__lead">A new space to originate and secure ideas.</h1>
    <div class="btn__group login__buttons">
        <button class="btn btn--primary has-icon login__google" on:click={loginGoogle}>
            Continue with Google
            <Icon data={google} stroke="none" ></Icon>
        </button>
        <button class="btn btn--primary has-icon login__google" on:click={loginTwitter}>
            Continue with Twitter
            <Icon data={twitter} stroke="none" ></Icon>
        </button>
        <button class="btn btn--primary has-icon login__google" on:click={loginFacebook}>
            Continue with Facebook
            <Icon data={facebook} stroke="none"></Icon>
        </button>
    </div>
</div>
{:else}
    <Splash {loginFailed}/>
{/if}